import { VirtualTableHeadCell } from '../../virtualized-table/types';
import FileNameUsername from "./file-name-username";

export const headCells: VirtualTableHeadCell[] = [
  {
    accessor: 'id',
    Header: 'Record ID',
    show: false,
  },
  {
    accessor: 'deviceId',
    Header: 'Device ID',
  },
  {
    accessor: 'assetSerialNumber',
    Header: 'Asset SN',
  },
  {
    accessor: 'deviceKey',
    Header: 'Device Key',
  },
  {
    accessor: 'transactionType',
    Header: 'Transaction Type',
  },
  {
    accessor: 'type',
    Header: 'Record Type',

  },
  {
    accessor: 'description',
    Header: 'Description'
  },
  {
    accessor: 'fileTypeName',
    Header: 'File Name / User ID',
    component: FileNameUsername
  },
  {
    accessor: 'fileSize',
    Header: 'File Size',
  },
  {
    accessor: 'applicationId',
    Header: 'Application ID',
  },
  {
    accessor: 'messageCreationTime',
    Header: 'Creation TS',
  },
  {
    accessor: 'gatewayReceiptTime',
    Header: 'GW Receipt TS',
  },
  {
    accessor: 'status',
    Header: 'Status',
  },
  {
    accessor: 'endpointOrCommandTs',
    Header: 'Sent to Endpoint / Status TS',
  },
  {
    accessor: 'lastUpdateTime',
    Header: 'Last Update Time',
  }
];

export const vimsTransactionsHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'id',
    Header: 'Record ID',
    show: false,
  },
  {
    accessor: 'assetSerialNumber',
    Header: 'Asset SN',
  },
  {
    accessor: 'transactionType',
    Header: 'Transaction Type',
  },
  {
    accessor: 'description',
    Header: 'Description'
  },
  {
    accessor: 'fileTypeName',
    Header: 'File Name / User ID',
    component: FileNameUsername
  },
  {
    accessor: 'fileSize',
    Header: 'File Size',
  },
  {
    accessor: 'messageCreationTime',
    Header: 'Creation TS',
  },
  {
    accessor: 'gatewayReceiptTime',
    Header: 'GW Receipt TS',
  },
  {
    accessor: 'endpointOrCommandTs',
    Header: 'Sent to Endpoint / Status TS',
  },
];

export const sortableAccessors = {
  gatewayReceiptTime: true,
  messageCreationTime: true,
};
